import Axios from 'axios';

const objIsEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

export default {
  getContent({ dispatch }, token) {
    const calls = [dispatch('getPageCopy', token), dispatch('getConfig')];
    if (token === 'works' || token === 'worksLongFormat' || token === 'directors' || token === 'locations' || token === 'clients') calls.push(dispatch('getItems', token));
    if (token === 'home' || token === 'directors' || token === 'production') calls.push(dispatch('getItems', 'works'));
    if (token === 'aboutus') calls.push(dispatch('getItems', 'teamMembers'));
    return new Promise((resolve, reject) => {
      Promise.all(calls).then(values => {
        resolve(values);
      });
    });
  },
  getConfig({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (!objIsEmpty(state.config)) {
        resolve();
        return;
      }
      Axios.get(`/content/Config?langAlias=${state.lang}`).then((response) => {
        commit('writeConfig', response.data);
        resolve();
      });
    });
  },
  getItems({ state, commit }, token) {
    return new Promise((resolve, reject) => {
      if (state[token].length) {
        resolve();
        return;
      }
      Axios.get(`/content/${token}?langAlias=${state.lang}`).then((response) => {
        commit('writeItem', { item: token, data: response.data });
        resolve();
      });
    });
  },
  getPageCopy({ state }, token) {
    return new Promise((resolve, reject) => {
      if (!objIsEmpty(state[`${token}Copy`])) {
        resolve();
        return;
      }
      Axios.get(`/content/${token}page?langAlias=${state.lang}`).then((response) => {
        const copyObject = response.data;
        document.querySelector('html').setAttribute('lang', state.lang);
        for (let meta in copyObject) {
          switch (meta) {
            case 'openGraphTitle':
              document.querySelector('meta[property="og:title"]').setAttribute("content", copyObject[meta]);
              break;
            case 'seoTitle':
              document.querySelector('title').innerHTML = `Production Portugal - ${copyObject[meta]}`;
              break;
            case 'openGraphImage':
              document.querySelector('meta[property="og:image"]').setAttribute("content", copyObject[meta]);
              break;
            case 'openGraphDescription':
              document.querySelector('meta[property="og:description"]').setAttribute("content", copyObject[meta]);
              break;
            case 'seoDescription':
              document.querySelector('meta[name="description"]').setAttribute("content", copyObject[meta]);
              break;
            case 'seoKeywords':
              document.querySelector('meta[name="keywords"]').setAttribute("content", copyObject[meta] && copyObject[meta].join(', '));
              break;
            default:
              break;
          }
        };
        state[`${token}Copy`] = copyObject;
        resolve();
      });
    });
  },
  changeLang({ state, commit, dispatch }, token) {
    commit('toggleBars');
    setTimeout(() => {
      commit('cleanStore');
      state.lang = token.newLang;
      dispatch('getContent', token.route).then(response => {
        commit('toggleBars');
      })
    }, 1000);
  },
  subscribeNL(store, token) {
    const apiKey = '07053bd4f7656c477ecfb2d4e357e83c-us7';
    const dc = apiKey.split("-")[1];
    const listId = '983b6ffc52';
    const url = `https://cors-anywhere.herokuapp.com/https://${dc}.api.mailchimp.com/3.0/lists/${listId}/members/`;
    const data = {
      'email_address': token,
      'status': 'subscribed',
      'status_if_new': "subscribed",
      'merge_fields': {
        'EMAIL': token,
        'FNAME': 'unset',
        'MMERGE4': 'Portugal',
      }
    };
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${apiKey}`
    };
    return new Promise((resolve, reject) => {
      Axios.post(url, data, { headers }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error.title)
      })
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js